import React from "react";
import { Button } from "rsuite";
import { useEffect,  } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup"
import logo from "../../assets/logo.png";
import {decode as base64_decode, encode as base64_encode} from 'base-64';
import { useDispatch, useSelector } from "react-redux";
import {
  allClientes,
  updateCliente,
  filterClientes,
  loginSession,
  resetStep1,
  resetStep2
} from "../../store/modules/cliente/actions";
import { Link } from "react-router-dom";
import CameraInput from "../../components/camera" 

export default function Login() {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "user"
  };
  
  

  const { clientes, behavior, form, components, code, loginCliente, step1,step2,  auth,cliente } = useSelector(
    (state) => state.cliente
  );

  const setComponent = (component, state) => {
    dispatch(
      updateCliente({
        components: { ...components, [component]: state },
      })
    );
  };

  const setCliente = (key, value) => {

        dispatch(
          updateCliente({
            loginCliente: { ...loginCliente, [key]: value },
          })
        );
  };

  function restart(){

    dispatch(
      updateCliente({
        form: { ...form, steps: 1 }
      })
    );
    

  }

const cerarCampos=()=>{
resetStep1()
resetStep2() 
restart()

console.log(step1, step2 , code.id, form.steps,  form.codeOk , "final")

}


const handleSubmit = async(e) => {

  e.preventDefault();
  if (!(await loginValidator())) return;
  
    dispatch(
      loginSession(loginCliente))
 
};



  useEffect(() => {
    
   if(auth.id.trim().length > 0){
    !cliente.isAdmin?
    
      navigate ("/reserva")
    :
 
      navigate ("/admin")
    
     
   }
  }, [handleSubmit]);


  async function loginValidator() {
    
      let schema = yup.object().shape({
   
        email: yup
          .string("Erro: Necessário preencher o campo email")
          .email("Erro: Necessário preencher o campo email").required(),
        password: yup
          .string("Erro: Necessário preencher o campo passsword")
          .required("Erro: Necessário preencher o campo passsword"),
      });



      try {
        await schema.validate(loginCliente);
        return true;
      } catch (error) {
        dispatch(
          updateCliente({
            form: { ...form, type: "error", messageError: error.errors },
          })
        );
        return false;
      }
    
  }





  return (
    <div className=" d-flex flex-column bd-highlight mb-3   justify-content-center  bg-dark align-items-center  ">

    
      <form onSubmit={handleSubmit}>
<div className=" bd-highlight mb-3  col-12 col-sm-8  col-md-10 col-lg-10 col-xl-10 " >
{
      form.fail === true? (<div className="p-3 mb-2 bg-danger text-white">`${form.errorTag}`</div>) : <></>
     } 
 
   
      <img src={logo} className=" col-12 card  mt-0 mb-3  border border-secondary"/>
      {form.type === "success" ? (
            <div className="alert alert-success" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
          {form.type === "error" ? (
            <div className="alert alert-danger" role="alert">
              {form.messageError}
            </div>
          ) : (
            ""
          )}
      <div className="form-group  col-12 mt-3 mb-3">
        <div className="input-group ">
          <input
          name="email"
            type="email"
            className="form-control"
            placeholder="Digite seu e-mail"
            value={loginCliente.email}
            onChange={(e) => {
              setCliente("email", e.target.value);
            }}
          />
        </div>
          {!loginCliente.email.includes("@") && loginCliente.email.length > 2 && (
              <span className=" text-white ">Incluir @</span>
            )}

      </div>
      <div className="form-group   col-12 mt-3 mb-3">
        <div className="input-group ">
          <input
          name="password"
            type="password"
            className="form-control"
            placeholder="Digite seu password"
            value={base64_decode(loginCliente.password)}
            onChange={(e) => {
              setCliente("password",base64_encode(e.target.value));
            }}
          />
        </div>
      </div>
     
     
     </div>
    
   <div className=" d-flex flex-column bd-highlight  col-12 col-sm-8  col-md-10 col-lg-10 col-xl-10  ">

      <Button
        appearance="primary"
        color="green"
        loading={form.filtering}
        
                className="form-group  col-12  "
       size="sm"
       type="submit"
      >
        login
      </Button>
      <Button
        appearance="primary"
       
        loading={form.filtering}
   
                className="form-group  text-white  col-12 mt-3  "
       size="sm"
            onClick={()=> cerarCampos() }
      >
       
       <Link  className="form-group  text-white" to="/cadastro">Cadastrar</Link>
      </Button>
     

   </div>
      </form>

      
    </div>
  );
}
